import type { FC } from "react";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { SituationComparison } from "./SituationComparison";

export const DefaultMaximumMortgageResultComparison: FC<
  ThemeSlotPropsMap["maximumMortgageResultComparison"]
> = (props) => <SituationComparison {...props} />;
